export class FinancialProcessorViewModel {
    constructor(public Id: number, public Name: string, public TypeId: number) {
    }
}